import React, { createContext, useContext, useState } from "react";
import { SEND_EMAIL_API } from "../config/apiConfig";
import { securedFetch } from "../utils/api";

const EmailContext = createContext();

export const EmailProvider = ({ children }) => {
  const [sendEmailLoading, setSendEmailLoading] = useState(false);
  const [sendEmailError, setSendEmailError] = useState(null);

  const sendEmail = async ({
    subject,
    templateName,
    variable = {},
    attachments,
  }) => {
    try {
      setSendEmailLoading(true);
      setSendEmailError(null);

      const formData = new FormData();

      formData.append("subject", subject);
      formData.append("templateName", templateName);
      formData.append("variable", JSON.stringify(variable));

      if (attachments) {
        formData.append("attachments", attachments);
      }

      securedFetch(SEND_EMAIL_API, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          setSendEmailLoading(false);
          if (response.ok) {
            alert("Email Sent Successfully!");
          } else {
            alert("Failed to send the Email!");
          }
        })
        .catch((err) => {
          setSendEmailError(err.message);
          alert("Failed to send the Email!");
          setSendEmailLoading(false);
        });
    } catch (err) {
      setSendEmailError(err.message);
      alert("Failed to send the Email!");
      setSendEmailLoading(false);
    }
  };

  return (
    <EmailContext.Provider
      value={{
        sendEmail,
        sendEmailLoading,
        setSendEmailLoading,
        sendEmailError,
        setSendEmailError,
      }}
    >
      {children}
    </EmailContext.Provider>
  );
};

export const useEmailContext = () => useContext(EmailContext);
